// Old links to the tax binder list land on the tax dashboard.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/preparer/tax-binders/')({
  beforeLoad: () => {
    throw redirect({
      to: '/preparer',
      replace: true,
    });
  },
  component: () => null,
});
